import React, { Component } from "react";
class InvalidRequestException extends Component {
  state = {};
  render() {
    return <div></div>;
  }
}

export default InvalidRequestException;
